import { Player, useGameContext } from "GameContext";

import {
  useState,
  useEffect,
} from "react";

import { getRoleConstants } from "utils/game-information-constants";

export default function PrivateHunter() {

  function renderHuntingLodge(){
    return (
      <div>
        <br/>
        <p>Hunting lodge upkeep cost: ${getRoleConstants("Hunter", "private")?.staticCosts[0][0]}</p>
        <br/>
        <p>Hunting lodge guard salary: ${getRoleConstants("Hunter", "private")?.staticCosts[1][0]}</p>
      </div>
    )
  }
  return (
    <div>
      <p>Hunt data</p>
      <br/>
      <br/>
      <p>Amount hunted may differ due to variability</p>
      <br/>
      {renderHuntingLodge()}
    </div>
  )

}
